/**
 * Shadow of @plone/volto-form-block/config/widgets (#1756).
 *
 * Upstream 1.0.0-alpha.3 registers its captcha widgets through
 * `config.registerWidget({ key, definition })`. That API arrived with the
 * @plone/registry of Volto 19; Volto 18.32.4 pins 2.7.0, which only knows
 * registerComponent/registerUtility/registerRoute. Without this shadow Volto
 * dies on boot with "config.registerWidget is not a function" -- the build
 * succeeds, the server never comes up.
 *
 * The widget list below is upstream's, written the Volto 18 way
 * (`config.widgets.widget[name]`). Delete this file together with the
 * @plone/types ambient declaration when we upgrade Volto, so the package's own
 * module takes over again.
 */
import type { ConfigType } from '@plone/registry';
import HoneypotCaptchaWidget from '@plone/volto-form-block/components/Widgets/HoneypotCaptchaWidget';
import NorobotsCaptchaWidget from '@plone/volto-form-block/components/Widgets/NorobotsCaptchaWidget';
import GoogleReCaptchaWidget from '@plone/volto-form-block/components/Widgets/GoogleReCaptchaWidget';
import HCaptchaWidget from '@plone/volto-form-block/components/Widgets/HCaptchaWidget';

export default function install(config: ConfigType) {
  // Volto 18 types `config.widgets.widget` as a closed record of the widget
  // names it ships itself, so the captcha names are not assignable. At runtime
  // it is a plain lookup object -- the same one upstream's registerWidget call
  // writes into.
  const widgets = config.widgets.widget as unknown as Record<string, unknown>;

  widgets.honeypot = HoneypotCaptchaWidget;
  widgets['norobots-captcha'] = NorobotsCaptchaWidget;
  widgets.recaptcha = GoogleReCaptchaWidget;
  widgets.hcaptcha = HCaptchaWidget;

  return config;
}
